import { useQuery } from "@tanstack/react-query";
import { SystemMgmtService } from "../services/systemMgmt/systemMgmt.service";
import { SystemCode } from "../constants";
import { store } from "../store/store";

export const useSoftwares = () => {
  const accessToken = store.getState().user?.current?.accessToken;

  const { data = [], ...restResponse } = useQuery({
    queryKey: ["softwares"],
    queryFn: () => SystemMgmtService.getSoftwares(),
    enabled: !!accessToken,
  });

  const getITLeadITHeadAssignee = (eSystemCode: SystemCode) => {
    const software: any = data.find((f: any) => f.eSystemCode === eSystemCode);
    const eApprovedByITLead = `${software?.eITTeamLead}|${software?.eTeamLeadName}`;
    const eApprovedByITHead = `${software?.eITHead}|${software?.eITHeadName}`;
    const eAssignee = software?.eITStaff;
    const softwareId = software?.id;
    const softwareTitle = software?.Title;

    return { eApprovedByITLead, eApprovedByITHead, eAssignee, softwareId, softwareTitle };
  };

  const getITLeadITHeadAssigneeById = (id: string) => {
    const software: any = data.find((f: any) => f.id === id);
    const eApprovedByITLead = `${software?.eITTeamLead}|${software?.eTeamLeadName}`;
    const eApprovedByITHead = `${software?.eITHead}|${software?.eITHeadName}`;
    const eAssignee = software?.eITStaff;
    const softwareId = software?.id;
    const softwareTitle = software?.Title;

    return { eApprovedByITLead, eApprovedByITHead, eAssignee, softwareId, softwareTitle };
  };
  return { data, ...restResponse, getITLeadITHeadAssignee, getITLeadITHeadAssigneeById };
};
